import React from "react";
import ProductListContext from './ProductListContext'
import { ApolloConsumer, gql } from '@apollo/client';

export default class ProductProvider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            productIds: [],
            search: '',
            showFilters: false,
            filter: {
                category: '',
                code: '',
                type: '',
                style: '',
                species: '',
                brand: '',
                supplier: '',
            },
        }
    }

    render() {
        return (
            <ApolloConsumer>
                {apolloClient => {
                    return (
                        <ProductListContext.Provider value={{
                            state: this.state,
                            setState: (obj) => {
                                this.setState(obj)
                            },
                            searchProduct: () => {
                                // Search functionality can be implemented here if needed
                            },
                            filterProducts: () => {
                                this.setState({
                                    showFilters: false,
                                })
                            },
                            clearFilters: () => {
                                this.setState({
                                    filter: {
                                        category: '',
                                        code: '',
                                        type: '',
                                        style: '',
                                        species: '',
                                        brand: '',
                                        supplier: '',
                                    },
                                })
                            },
                            closeFilters: () => {
                                this.setState({
                                    showFilters: false,
                                    filter: {
                                        category: '',
                                        code: '',
                                        type: '',
                                        style: '',
                                        species: '',
                                        brand: '',
                                        supplier: '',
                                    },
                                })
                            },
                            showFilter: () => {
                                this.setState({
                                    showFilters: true
                                })
                            }
                        }}>
                            {this.props.children}
                        </ProductListContext.Provider>
                    )
                }}
            </ApolloConsumer>
        )
    }
}
